<template>
	<div :class="[{narrow}, color || '']" class="dark banner-container shadow bg-gray-650">
		<div v-if="$slots.icon" class="mr-8 inline-block">
			<slot name="icon" />
		</div>
		<div :class="contentClass">
			<slot />
		</div>
	</div>
</template>
<script>
export default {
	name: 'BaseBanner',
	props: {
		contentClass: {type: String, default: null},
		narrow: Boolean,
		color: {type: String, default: null},
	},
}
</script>

<style scoped>
.banner-container {
	position: relative;
	display: flex;
	flex-shrink: 0;
	padding: 6px 8px;
	border-radius: var(--border-radius-lg);
	color: var(--gray-300);
}

.green {
	border-top: 2px solid var(--green-500);
}

.red {
	border-top: 2px solid var(--red-500);
}

.yellow {
	border-top: 2px solid var(--yellow-500);
}

.narrow {
	max-width: 600px;
}
</style>
